import OrderListPage from 'pages/OrderListPage/OrderListPage';

export default OrderListPage;
